/**
 * Anecdotes API
 * Anecdotes API's
 *
 * OpenAPI spec version: 0.0.3
 * Contact: apiteam@anecdotes.ai
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface Applicability {
  /**
   * whether applicable or not
   */
  is_applicable: boolean;
  /**
   * the type of the entity which this applicability refer to
   */
  applicability_type: ApplicabilityTypeEnum;
  /**
   * the id of the entity which this applicability refer to
   */
  applicability_id: string;
}

export type ApplicabilityTypeEnum = 'CONTROL' | 'EVIDENCE' | 'REQUIREMENT' | 'FRAMEWORK';
export const ApplicabilityTypeEnum = {
  CONTROL: 'CONTROL' as ApplicabilityTypeEnum,
  EVIDENCE: 'EVIDENCE' as ApplicabilityTypeEnum,
  REQUIREMENT: 'REQUIREMENT' as ApplicabilityTypeEnum,
  FRAMEWORK: 'FRAMEWORK' as ApplicabilityTypeEnum,
};
